import { useEffect } from 'react';
import { trackPageView } from '../utils/analytics';

/**
 * Hook to track page views in Google Analytics for SPA navigation
 * Listens to hash changes and sends pageview events (only after the visitor accepted analytics)
 */
export const usePageTracking = () => {
  useEffect(() => {
    // Track initial page load
    trackPageView();

    // Track hash changes (SPA navigation)
    window.addEventListener('hashchange', trackPageView);

    return () => {
      window.removeEventListener('hashchange', trackPageView);
    };
  }, []);
};
